document.addEventListener('DOMContentLoaded', function () {
  const giftEditContainer = document.querySelector('.gift-card-message-container-product');
  const giftEditSaveBtn = document.querySelector('.gift-card-message-save-product');

  document.body.addEventListener('click', function (event) {
    const savedMessage = localStorage.getItem('giftCardMessage');
    if (savedMessage) {
      document.querySelector('.gift-card-message-product').value = savedMessage;
    }
    if (event.target.classList.contains('gift-card-edit')) {
      giftEditContainer.classList.add('active');
    }
  });

  giftEditSaveBtn.addEventListener('click', () => {
    const giftCardMessageTextArea = document.querySelector('.gift-card-message-product');
    if (giftCardMessageTextArea.value.trim()) {
      localStorage.setItem('giftCardMessage', giftCardMessageTextArea.value.trim());
    }
    giftEditContainer.classList.remove('active');
  });
});
